module.exports = __webpack_public_path__ + "static/media/headerLogo.36a3445f.png";